import { render } from "./LabelFormat.vue?vue&type=template&id=28f07da6"
import script from "./LabelFormat.vue?vue&type=script&lang=js"
export * from "./LabelFormat.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.13.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__